module.exports = __webpack_public_path__ + "assets/wp-statistics.a5a233ae.svg";